package com.evoapps.evoshift.ui.onboarding

import com.evoapps.evoshift.widgets.IconButtonWithTooltip
import com.evoapps.evoshift.widgets.rememberStableText
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.KeyboardArrowRight
import androidx.compose.material.icons.automirrored.filled.TrendingUp
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.Business
import androidx.compose.material.icons.filled.CalendarMonth
import androidx.compose.material.icons.filled.Check
import androidx.compose.material.icons.filled.CheckCircle
import com.evoapps.evoshift.ui.legal.WorkplaceDpaNote
import evoshift.composeapp.generated.resources.setup_allow
import evoshift.composeapp.generated.resources.setup_granted
import androidx.compose.material.icons.filled.GroupAdd
import androidx.compose.material.icons.filled.Payments
import androidx.compose.material.icons.filled.Remove
import androidx.compose.material.icons.filled.SwapHoriz
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.selected
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardCapitalization
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.domain.market.Market
import com.evoapps.evoshift.domain.model.InviteDetails
import com.evoapps.evoshift.domain.usecase.OpeningHours
import com.evoapps.evoshift.domain.usecase.StarterScheduleNames
import com.evoapps.evoshift.domain.usecase.StarterShiftKind
import com.evoapps.evoshift.ui.CardBlue
import com.evoapps.evoshift.ui.DarkGold
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.GoldMetallicBrush
import com.evoapps.evoshift.ui.LightGold
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.adaptive.hoverLift
import com.evoapps.evoshift.ui.util.TestTags
import com.evoapps.evoshift.ui.util.UiText
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.ui.util.dayShort
import com.evoapps.evoshift.widgets.GoldButton
import com.evoapps.evoshift.widgets.StandoutCard
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.app_logo
import evoshift.composeapp.generated.resources.create_workplace_business_hint
import evoshift.composeapp.generated.resources.create_workplace_business_name
import evoshift.composeapp.generated.resources.create_workplace_label
import evoshift.composeapp.generated.resources.create_workplace_name_hint
import evoshift.composeapp.generated.resources.join_team_invited_by
import evoshift.composeapp.generated.resources.join_team_workplace
import evoshift.composeapp.generated.resources.onboarding_business_desc
import evoshift.composeapp.generated.resources.onboarding_business_title
import evoshift.composeapp.generated.resources.onboarding_day_template
import evoshift.composeapp.generated.resources.onboarding_finance_desc
import evoshift.composeapp.generated.resources.onboarding_finance_no
import evoshift.composeapp.generated.resources.onboarding_finance_no_desc
import evoshift.composeapp.generated.resources.onboarding_finance_title
import evoshift.composeapp.generated.resources.onboarding_finance_yes
import evoshift.composeapp.generated.resources.onboarding_finance_yes_desc
import evoshift.composeapp.generated.resources.onboarding_get_started
import evoshift.composeapp.generated.resources.onboarding_hours_closes
import evoshift.composeapp.generated.resources.onboarding_hours_days
import evoshift.composeapp.generated.resources.onboarding_hours_desc
import evoshift.composeapp.generated.resources.onboarding_hours_earlier
import evoshift.composeapp.generated.resources.onboarding_hours_later
import evoshift.composeapp.generated.resources.onboarding_hours_opens
import evoshift.composeapp.generated.resources.onboarding_hours_preview
import evoshift.composeapp.generated.resources.onboarding_hours_title
import evoshift.composeapp.generated.resources.onboarding_invite_code_label
import evoshift.composeapp.generated.resources.onboarding_invite_code_placeholder
import evoshift.composeapp.generated.resources.onboarding_join_check
import evoshift.composeapp.generated.resources.onboarding_join_confirm
import evoshift.composeapp.generated.resources.onboarding_join_desc
import evoshift.composeapp.generated.resources.onboarding_join_title
import evoshift.composeapp.generated.resources.onboarding_market
import evoshift.composeapp.generated.resources.onboarding_market_desc
import evoshift.composeapp.generated.resources.onboarding_market_poland
import evoshift.composeapp.generated.resources.onboarding_next
import evoshift.composeapp.generated.resources.onboarding_role_join
import evoshift.composeapp.generated.resources.onboarding_role_join_desc
import evoshift.composeapp.generated.resources.onboarding_role_owner
import evoshift.composeapp.generated.resources.onboarding_role_owner_desc
import evoshift.composeapp.generated.resources.onboarding_role_title
import evoshift.composeapp.generated.resources.onboarding_shift_evening
import evoshift.composeapp.generated.resources.onboarding_shift_full_day
import evoshift.composeapp.generated.resources.onboarding_shift_morning
import evoshift.composeapp.generated.resources.onboarding_skip
import evoshift.composeapp.generated.resources.onboarding_welcome_desc
import evoshift.composeapp.generated.resources.onboarding_welcome_point_costs
import evoshift.composeapp.generated.resources.onboarding_welcome_point_rosters
import evoshift.composeapp.generated.resources.onboarding_welcome_point_team
import evoshift.composeapp.generated.resources.onboarding_welcome_title
import evoshift.composeapp.generated.resources.onboarding_workplace_desc
import evoshift.composeapp.generated.resources.onboarding_workplace_title
import kotlinx.datetime.DayOfWeek
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

/**
 * The onboarding steps (SH-38), each stateless so the interaction tests drive them as
 * EVoLabels' FirstProductsAndPlansInteractionTest does. Navy and gold, Open Sans; every field
 * moves on with the keyboard's action key.
 */

private val Muted = Color.White.copy(alpha = 0.78f)

@Composable
internal fun StepHeader(title: String, description: String?) {
    Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(8.dp)) {
        Text(title, style = MaterialTheme.typography.headlineSmall, color = LightGold, fontWeight = FontWeight.Bold)
        if (description != null) Text(description, style = MaterialTheme.typography.bodyLarge, color = Muted)
    }
}

@Composable
fun WelcomeStep(onStart: () -> Unit) {
    Column(
        Modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(20.dp)
    ) {
        Image(painterResource(Res.drawable.app_logo), contentDescription = null, modifier = Modifier.size(96.dp))
        Text(
            stringResource(Res.string.onboarding_welcome_title),
            style = MaterialTheme.typography.headlineMedium,
            color = LightGold,
            fontWeight = FontWeight.Bold,
            textAlign = TextAlign.Center
        )
        Text(stringResource(Res.string.onboarding_welcome_desc), color = Muted, textAlign = TextAlign.Center)
        StandoutCard(Modifier.fillMaxWidth()) {
            Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(14.dp)) {
                WelcomePoint(Icons.Default.CalendarMonth, stringResource(Res.string.onboarding_welcome_point_rosters))
                WelcomePoint(Icons.Default.SwapHoriz, stringResource(Res.string.onboarding_welcome_point_team))
                WelcomePoint(Icons.Default.Payments, stringResource(Res.string.onboarding_welcome_point_costs))
            }
        }
        GoldButton(
            stringResource(Res.string.onboarding_get_started),
            onStart,
            Modifier.fillMaxWidth().testTag(TestTags.ONBOARDING_START)
        )
    }
}

@Composable
private fun WelcomePoint(icon: ImageVector, text: String) {
    Row(verticalAlignment = Alignment.CenterVertically) {
        Box(Modifier.size(36.dp).background(GoldMetallicBrush, CircleShape), contentAlignment = Alignment.Center) {
            Icon(icon, contentDescription = null, tint = DeepNavy, modifier = Modifier.size(20.dp))
        }
        Spacer(Modifier.width(12.dp))
        Text(text, color = Color.White, style = MaterialTheme.typography.bodyLarge)
    }
}

@Composable
fun RoleStep(onOwner: () -> Unit, onJoin: () -> Unit) {
    Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(16.dp)) {
        StepHeader(stringResource(Res.string.onboarding_role_title), null)
        ChoiceCard(
            icon = Icons.Default.Business,
            title = stringResource(Res.string.onboarding_role_owner),
            description = stringResource(Res.string.onboarding_role_owner_desc),
            onClick = onOwner,
            modifier = Modifier.testTag(TestTags.ONBOARDING_ROLE_OWNER)
        )
        ChoiceCard(
            icon = Icons.Default.GroupAdd,
            title = stringResource(Res.string.onboarding_role_join),
            description = stringResource(Res.string.onboarding_role_join_desc),
            onClick = onJoin,
            modifier = Modifier.testTag(TestTags.ONBOARDING_ROLE_JOIN)
        )
    }
}

@Composable
private fun ChoiceCard(icon: ImageVector, title: String, description: String, onClick: () -> Unit, modifier: Modifier = Modifier) {
    StandoutCard(modifier = modifier.fillMaxWidth().hoverLift(), onClick = onClick) {
        Row(Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
            Icon(icon, contentDescription = null, tint = LightGold, modifier = Modifier.size(40.dp))
            Spacer(Modifier.width(16.dp))
            Column(Modifier.weight(1f)) {
                Text(title, style = MaterialTheme.typography.titleLarge, color = LightGold, fontWeight = FontWeight.Bold)
                Text(description, style = MaterialTheme.typography.bodyMedium, color = Muted)
            }
            Icon(Icons.AutoMirrored.Filled.KeyboardArrowRight, contentDescription = null, tint = LightGold)
        }
    }
}

/** A text field on navy: light text, gold focus, readable cursor and handles. */
@Composable
internal fun BrandTextField(
    value: String,
    onValueChange: (String) -> Unit,
    label: String,
    placeholder: String,
    error: UiText?,
    onDone: () -> Unit,
    modifier: Modifier = Modifier,
    capitalization: KeyboardCapitalization = KeyboardCapitalization.Words,
    imeAction: ImeAction = ImeAction.Next
) {
    rememberStableText(value, onValueChange).let { stable ->
        OutlinedTextField(
            value = stable.value,
            onValueChange = stable.onValueChange,
            label = { Text(label) },
            placeholder = { Text(placeholder) },
            singleLine = true,
            isError = error != null,
            supportingText = error?.let { { Text(it.asString()) } },
            keyboardOptions = KeyboardOptions(capitalization = capitalization, autoCorrectEnabled = false, imeAction = imeAction),
            keyboardActions = KeyboardActions(onNext = { onDone() }, onDone = { onDone() }, onGo = { onDone() }),
            colors = OutlinedTextFieldDefaults.colors(
                cursorColor = LightGold,
                focusedBorderColor = LightGold,
                unfocusedBorderColor = Color.White.copy(alpha = 0.35f),
                focusedLabelColor = LightGold,
                unfocusedLabelColor = Color.White.copy(alpha = 0.6f),
                focusedTextColor = Color.White,
                unfocusedTextColor = Color.White,
                focusedPlaceholderColor = Color.White.copy(alpha = 0.6f),
                unfocusedPlaceholderColor = Color.White.copy(alpha = 0.6f),
                errorTextColor = Color.White,
                errorSupportingTextColor = Color(0xFFFFB4AB),
                errorBorderColor = Color(0xFFFFB4AB),
                errorLabelColor = Color(0xFFFFB4AB),
                errorCursorColor = LightGold
            ),
            modifier = modifier.fillMaxWidth()
        )
    }
}

@Composable
fun BusinessStep(name: String, error: UiText?, isSaving: Boolean, onNameChange: (String) -> Unit, onNext: () -> Unit) {
    Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(20.dp)) {
        StepHeader(stringResource(Res.string.onboarding_business_title), stringResource(Res.string.onboarding_business_desc))
        BrandTextField(
            value = name,
            onValueChange = onNameChange,
            label = stringResource(Res.string.create_workplace_business_name),
            placeholder = stringResource(Res.string.create_workplace_business_hint),
            error = error,
            onDone = onNext,
            modifier = Modifier.testTag(TestTags.ONBOARDING_BUSINESS_NAME)
        )
        GoldButton(stringResource(Res.string.onboarding_next), onNext, Modifier.fillMaxWidth().testTag(TestTags.ONBOARDING_NEXT), isBusy = isSaving)
    }
}

@Composable
fun WorkplaceStep(
    name: String,
    market: Market,
    error: UiText?,
    isSaving: Boolean,
    onNameChange: (String) -> Unit,
    onNext: () -> Unit
) {
    Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(20.dp)) {
        StepHeader(stringResource(Res.string.onboarding_workplace_title), stringResource(Res.string.onboarding_workplace_desc))
        BrandTextField(
            value = name,
            onValueChange = onNameChange,
            label = stringResource(Res.string.create_workplace_label),
            placeholder = stringResource(Res.string.create_workplace_name_hint),
            error = error,
            onDone = onNext,
            imeAction = ImeAction.Done,
            modifier = Modifier.testTag(TestTags.ONBOARDING_WORKPLACE_NAME)
        )
        StandoutCard(Modifier.fillMaxWidth()) {
            Row(Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
                Text(market.flag, style = MaterialTheme.typography.headlineMedium)
                Spacer(Modifier.width(12.dp))
                Column {
                    Text(
                        "${stringResource(Res.string.onboarding_market)}: ${stringResource(Res.string.onboarding_market_poland)}",
                        color = LightGold,
                        fontWeight = FontWeight.Bold
                    )
                    Text(
                        stringResource(Res.string.onboarding_market_desc, market.currency, market.timezone),
                        color = Muted,
                        style = MaterialTheme.typography.bodySmall
                    )
                }
            }
        }
        GoldButton(stringResource(Res.string.onboarding_next), onNext, Modifier.fillMaxWidth().testTag(TestTags.ONBOARDING_NEXT), isBusy = isSaving)
        // Opening the workplace accepts the data processing annex; CreateWorkplaceUseCase records it (SH-50).
        WorkplaceDpaNote(color = Muted)
    }
}

/** Names of the starter shifts in the owner's language (stored as data, so resolved here). */
@Composable
internal fun starterScheduleNames() = StarterScheduleNames(
    fullDay = stringResource(Res.string.onboarding_shift_full_day),
    morning = stringResource(Res.string.onboarding_shift_morning),
    evening = stringResource(Res.string.onboarding_shift_evening),
    dayTemplate = stringResource(Res.string.onboarding_day_template)
)

@Composable
fun HoursStep(
    hours: OpeningHours,
    error: UiText?,
    isSaving: Boolean,
    onToggleDay: (Int) -> Unit,
    onShiftOpening: (Int) -> Unit,
    onShiftClosing: (Int) -> Unit,
    onNext: (StarterScheduleNames) -> Unit,
    onSkip: () -> Unit
) {
    val names = starterScheduleNames()
    Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(18.dp)) {
        StepHeader(stringResource(Res.string.onboarding_hours_title), stringResource(Res.string.onboarding_hours_desc))
        Text(stringResource(Res.string.onboarding_hours_days), color = LightGold, style = MaterialTheme.typography.titleSmall)
        OpenDayChips(hours.openDays, onToggleDay)
        TimeStepper(
            label = stringResource(Res.string.onboarding_hours_opens),
            time = OpeningHours.clock(hours.opensAtMinutes),
            onEarlier = { onShiftOpening(-30) },
            onLater = { onShiftOpening(30) },
            earlierTag = TestTags.ONBOARDING_OPENS_EARLIER,
            laterTag = TestTags.ONBOARDING_OPENS_LATER
        )
        TimeStepper(
            label = stringResource(Res.string.onboarding_hours_closes),
            time = if (hours.closesAtMinutes == OpeningHours.MINUTES_PER_DAY) "24:00" else OpeningHours.clock(hours.closesAtMinutes),
            onEarlier = { onShiftClosing(-30) },
            onLater = { onShiftClosing(30) },
            earlierTag = TestTags.ONBOARDING_CLOSES_EARLIER,
            laterTag = TestTags.ONBOARDING_CLOSES_LATER
        )
        val shifts = hours.starterShifts()
        if (shifts.isNotEmpty()) {
            StandoutCard(Modifier.fillMaxWidth()) {
                Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                    Text(stringResource(Res.string.onboarding_hours_preview), color = LightGold, style = MaterialTheme.typography.titleSmall)
                    shifts.forEach { shift ->
                        Row(Modifier.fillMaxWidth()) {
                            Text(
                                when (shift.kind) {
                                    StarterShiftKind.FULL_DAY -> names.fullDay
                                    StarterShiftKind.MORNING -> names.morning
                                    StarterShiftKind.EVENING -> names.evening
                                },
                                color = Color.White,
                                modifier = Modifier.weight(1f)
                            )
                            Text("${shift.startTime} – ${shift.endTime}", color = Color.White, fontWeight = FontWeight.Bold)
                        }
                    }
                }
            }
        }
        error?.let { Text(it.asString(), color = Color(0xFFFFB4AB)) }
        GoldButton(stringResource(Res.string.onboarding_next), { onNext(names) }, Modifier.fillMaxWidth().testTag(TestTags.ONBOARDING_NEXT), isBusy = isSaving)
        TextButton(onClick = onSkip, enabled = !isSaving, modifier = Modifier.align(Alignment.CenterHorizontally).testTag(TestTags.ONBOARDING_SKIP)) {
            Text(stringResource(Res.string.onboarding_skip), color = Color.White)
        }
    }
}

/**
 * Financial planning (SH-61): planning labour cost against sales needs the weekly sales plan
 * (the settings' SalesTargetsDialog opens on "yes"); "no" goes on without one.
 */
@Composable
fun FinanceStep(onAnswer: (plansFinances: Boolean) -> Unit) {
    Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(16.dp)) {
        StepHeader(stringResource(Res.string.onboarding_finance_title), stringResource(Res.string.onboarding_finance_desc))
        ChoiceCard(
            icon = Icons.AutoMirrored.Filled.TrendingUp,
            title = stringResource(Res.string.onboarding_finance_yes),
            description = stringResource(Res.string.onboarding_finance_yes_desc),
            onClick = { onAnswer(true) },
            modifier = Modifier.testTag(TestTags.ONBOARDING_FINANCE_YES)
        )
        ChoiceCard(
            icon = Icons.Default.CalendarMonth,
            title = stringResource(Res.string.onboarding_finance_no),
            description = stringResource(Res.string.onboarding_finance_no_desc),
            onClick = { onAnswer(false) },
            modifier = Modifier.testTag(TestTags.ONBOARDING_FINANCE_NO)
        )
    }
}

/** Monday to Sunday as round chips, [openDays] (ISO, 1 = Monday) selected; also the review's open days dialog. */
@Composable
internal fun OpenDayChips(openDays: Set<Int>, onToggleDay: (Int) -> Unit) {
    Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(6.dp)) {
        DayOfWeek.entries.forEachIndexed { index, day ->
            val iso = index + 1
            val selected = iso in openDays
            val label = dayShort(day)
            Box(
                Modifier
                    .weight(1f)
                    .widthIn(max = 52.dp)
                    .aspectRatio(1f)
                    .background(if (selected) DarkGold else Color.White.copy(alpha = 0.08f), CircleShape)
                    .border(1.dp, if (selected) LightGold else Color.White.copy(alpha = 0.3f), CircleShape)
                    .handCursor()
                    .clickable(role = Role.Checkbox) { onToggleDay(iso) }
                    .semantics { this.selected = selected; contentDescription = label }
                    .testTag(TestTags.day(iso)),
                contentAlignment = Alignment.Center
            ) {
                Text(label, color = if (selected) DeepNavy else Color.White, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.labelLarge)
            }
        }
    }
}

@Composable
private fun TimeStepper(label: String, time: String, onEarlier: () -> Unit, onLater: () -> Unit, earlierTag: String, laterTag: String) {
    Surface(color = CardBlue, shape = RoundedCornerShape(16.dp), border = BorderStroke(1.dp, Color.White.copy(alpha = 0.2f))) {
        Row(Modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 6.dp), verticalAlignment = Alignment.CenterVertically) {
            Text(label, color = Color.White, modifier = Modifier.weight(1f))
            IconButtonWithTooltip(onClick = onEarlier, modifier = Modifier.testTag(earlierTag), tooltip = stringResource(Res.string.onboarding_hours_earlier)) {
                Icon(Icons.Default.Remove, contentDescription = stringResource(Res.string.onboarding_hours_earlier), tint = LightGold)
            }
            Text(time, color = LightGold, style = MaterialTheme.typography.titleLarge, fontWeight = FontWeight.Bold)
            IconButtonWithTooltip(onClick = onLater, modifier = Modifier.testTag(laterTag), tooltip = stringResource(Res.string.onboarding_hours_later)) {
                Icon(Icons.Default.Add, contentDescription = stringResource(Res.string.onboarding_hours_later), tint = LightGold)
            }
        }
    }
}

@Composable
fun JoinStep(
    code: String,
    invite: InviteDetails?,
    error: UiText?,
    isSaving: Boolean,
    onCodeChange: (String) -> Unit,
    onCheck: () -> Unit,
    onJoin: () -> Unit
) {
    Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(20.dp)) {
        StepHeader(stringResource(Res.string.onboarding_join_title), stringResource(Res.string.onboarding_join_desc))
        BrandTextField(
            value = code,
            onValueChange = onCodeChange,
            label = stringResource(Res.string.onboarding_invite_code_label),
            placeholder = stringResource(Res.string.onboarding_invite_code_placeholder),
            error = error,
            onDone = if (invite == null) onCheck else onJoin,
            capitalization = KeyboardCapitalization.Characters,
            imeAction = ImeAction.Done,
            modifier = Modifier.testTag(TestTags.ONBOARDING_INVITE_CODE)
        )
        if (invite != null) {
            StandoutCard(Modifier.fillMaxWidth()) {
                Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
                    Text(stringResource(Res.string.join_team_workplace), color = Muted, style = MaterialTheme.typography.labelSmall)
                    Text(invite.workplaceName, color = LightGold, style = MaterialTheme.typography.titleLarge, fontWeight = FontWeight.Bold)
                    Spacer(Modifier.height(4.dp))
                    Text(stringResource(Res.string.join_team_invited_by), color = Muted, style = MaterialTheme.typography.labelSmall)
                    Text(invite.inviterName, color = Color.White)
                }
            }
            GoldButton(
                stringResource(Res.string.onboarding_join_confirm, invite.workplaceName),
                onJoin,
                Modifier.fillMaxWidth().testTag(TestTags.ONBOARDING_JOIN),
                isBusy = isSaving
            )
        } else {
            GoldButton(
                stringResource(Res.string.onboarding_join_check),
                onCheck,
                Modifier.fillMaxWidth().testTag(TestTags.ONBOARDING_JOIN),
                isBusy = isSaving
            )
        }
    }
}

/** A finished item in the summary of the last step. */
@Composable
internal fun SummaryLine(text: String) {
    Row(verticalAlignment = Alignment.CenterVertically) {
        Box(Modifier.size(22.dp).background(GoldMetallicBrush, CircleShape), contentAlignment = Alignment.Center) {
            Icon(Icons.Default.Check, contentDescription = null, tint = DeepNavy, modifier = Modifier.size(14.dp))
        }
        Spacer(Modifier.width(10.dp))
        Text(text, color = Color.White)
    }
}

@Composable
internal fun SmallProgress() = CircularProgressIndicator(Modifier.size(16.dp), color = LightGold, strokeWidth = 2.dp)

/** One permission the app recommends (moved from the old Setup screen). */
@Composable
internal fun PermissionItem(
    icon: ImageVector,
    title: String,
    description: String,
    isGranted: Boolean,
    onClick: () -> Unit
) {
    StandoutCard(modifier = Modifier.fillMaxWidth()) {
        Row(Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
            Icon(icon, contentDescription = null, modifier = Modifier.size(32.dp), tint = if (isGranted) LightGold else Color.White.copy(alpha = 0.5f))
            Spacer(Modifier.width(16.dp))
            Column(Modifier.weight(1f)) {
                Text(title, style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold, color = if (isGranted) LightGold else Color.White)
                Text(description, style = MaterialTheme.typography.bodySmall, color = Muted)
            }
            if (isGranted) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Text(stringResource(Res.string.setup_granted), style = MaterialTheme.typography.bodyMedium, color = LightGold, fontWeight = FontWeight.Bold)
                    Spacer(Modifier.width(8.dp))
                    Icon(Icons.Default.CheckCircle, contentDescription = null, tint = LightGold)
                }
            } else {
                TextButton(onClick = onClick) {
                    Text(stringResource(Res.string.setup_allow), color = LightGold, fontWeight = FontWeight.Bold)
                }
            }
        }
    }
}
